<template>
 <!--< :class="{ DocumentPlaceholderTableRow: index === 1 }">-->
  <div 
    class="min-h-12 grid gap-x-4 px-5 md:pl-12 md:pr-6 xl:pl-16 py-2 sm:items-center border-b"
    :class="[edit? 'gap-y-2' : '', showStock?'grid-cols-6 sm:grid-cols-9':'grid-cols-5 sm:grid-cols-8']"
  >
    <div class="col-span-3 sm:col-span-1 row-start-1 row-span-1 break-words">
      <contenteditable
        tag="span"
        v-model="product.code"
        :contenteditable="edit"
        :noNL="true"
        :noHTML="true"
        @updated="updated = 'code'"
        class="w-full h-auto"
        :class="edit? 'py-1.5 px-2 bg-gray-100 rounded' : ''"
        :auto-focus="!product.id"
        @focus="updateFocus()"
      />
    </div>
    <div class="col-span-3 row-start-2 sm:row-start-1 row-span-1 break-words">
      <contenteditable
        tag="span"
        v-model="product.name"
        :contenteditable="edit"
        :noNL="true"
        :noHTML="true"
        @updated="updated = 'name'"
        class="w-full h-full"
        :class="edit? 'py-1.5 px-2 bg-gray-100 rounded' : ''"
        @focus="updateFocus()"
      />
    </div>
    <div
      v-if="showStock"
      class="col-span-1 sm:col-span-1 row-span-2 sm:row-span-1 text-right break-words"
    >
      <span>{{ stock }}</span>
    </div>
    <div 
      v-if="edit"
      class="col-span-1 sm:col-span-2 row-span-2 sm:row-span-1 flex flex-col sm:flex-row sm:justify-end items-end sm:items-center break-words"
    >
      <span
        v-if="currency.symbol_infront"
        class="mr-2 mb-2 sm:mb-0"
      >{{ currency.symbol }}</span>
      <contenteditable
        tag="span"
        v-model="priceEdit"
        :contenteditable="edit"
        :noNL="true"
        :noHTML="true"
        @updated="updated = 'price'"
        class="w-full flex-inline py-1.5 px-2 text-right bg-gray-100 rounded"
        :onlyNumbers="true"
        alwaysSelectAll="0"
        @focus="updateFocus()"
      />
      <span 
        v-if="!currency.symbol_infront"
        class="ml-2 mt-2 sm:mt-0"
      >{{ currency.symbol }}</span>
    </div>
    <div
      v-if="!edit" 
      class="col-span-1 sm:col-span-2 row-span-2 sm:row-span-1 text-right break-words whitespace-break-spaces"
    >
      <span>
        {{ price }}
      </span>
    </div>
    <div
      v-if="edit"
      class="col-span-1 sm:col-span-2 text-right"
    >
      <aw-icon
        @click.stop.prevent="deleteProduct()"
        icon="trash"
        class="w-6 h-6 mx-3 cursor-pointer text-gray-400 hover:text-gray-500"
      ></aw-icon>
    </div>
    <div 
      class="col-span-1 sm:col-span-2 row-span-2 sm:row-span-1 text-right break-words" 
      v-if="!edit"
    >
      <input
        class="
          bg-gray-100
          p-1.5
          px-2
          text-sm
          border-0
          w-16
          text-right
          rounded
        "
        type="text"
        v-model="currentAmount"
      />
    </div>
    <div class="col-span-1 hidden">
      <!--
      <span
        class="DocumentCircle DocumentCircle--SM mr-2.5"
        :class="{
          'DocumentCircle--active':
            $store.state.bcSelected.selected[product.code]
        }"
        @click.stop="
          $store.dispatch('bcSelected/select', { item: product })
        "
      ></span>
      -->
      <!--
      <span class="cursor-move text-gray-400 hover:text-gray-500">
        <aw-icon
          icon="dots"
          class="w-4 h-4 -mx-1 "
        ></aw-icon>
        <aw-icon
          icon="dots"
          class="w-4 h-4 -mx-1 "
        ></aw-icon>
      </span>
      -->
    </div>
    <span 
      v-if="duplicateCode"
      class="row-start-3 sm:row-start-2 col-span-5 sm:col-span-8 text-red-600"
    >
      {{ $t('Product code "%code%" is already taken in this block', {code: product.code}) }}
    </span>
  </div>
</template>
<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import { DocumentApi } from '../../test-api/index.ts'
import { isNumber } from '@vueuse/shared'
import handleApiError from '../../utils/handleApiError'

const documentApi = new DocumentApi({}, '/api/v2')

export default {
  emits: ['update:modelValue', 'delete', 'update:amount', 'changeFocusIndex'],
  props: {
    modelValue: Object,
    amount: {
      type: Number,
      default: null,
    },
    page: Object,
    index: Number,
    showStock: Boolean,
    focusIndex: Number
  },
  data() {
    return {
      updated: null,
      focused: null,
      priceEdit: 0,
    }
  },
  computed: {
    ...mapStores(useBcDocumentStore, useBcSelectedStore),
    edit() {
      return this.bcDocumentStore.edit
    },
    product: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },
    currentAmount: {
      get () {
        return this.amount
      },
      set (val) {
        this.$emit('update:amount', isNumber(parseInt(val)) ? parseInt(val) : null)
      }
    },
    price() {
      return this.product.price
        ? this.product.price.price_formatted
        : ''
    },
    stock() {
      return this.product.stock
    },
    currency() {
      return this.$presenter.design.currency
    },
    duplicateCode() {
      return this.page.data.products.filter(
        (product, index) => index !== this.index && this.product.code && product.code && product.code.toString() === this.product.code.toString()
      ).length
    }
  },
  methods: {
    updateProduct(data, updatedKey) {
      if (data.product_id !== this.product.product_id) {
        this.product = data
        return
      }

      if (this.product['id'] !== data.id) {
        this.product['id'] = data.id
      }

      if (this.duplicateCode && updatedKey === 'code') {
        return
      }
      
      this.product[updatedKey] = data[updatedKey]
    },
    updateProductQueue(val) {
      const toUpdate = { rank: this.index }
      toUpdate[val] = val === 'price'
        ? (this.priceEdit && typeof this.priceEdit === 'string' ? parseFloat(this.priceEdit.replace(',', '.')) : 0)
        : this.product[val]

      if (this.duplicateCode && val === 'code') {
        toUpdate[val] = null
      }

      this.bcDocumentStore.addToUpdateQueue(() => {
        return new Promise((resolve/*, reject*/) => {
          // eslint-disable-next-line no-extra-semi
          let elementSavePromise
          if (this.product.id) {
            elementSavePromise = handleApiError(() => documentApi.elementUpdateProduct(this.bcDocumentStore.document.id, this.bcDocumentStore.documentRev, this.page.id, this.product.id, toUpdate))
          
          } else {
            elementSavePromise = handleApiError(() => documentApi.elementAddProduct(this.bcDocumentStore.document.id, this.bcDocumentStore.documentRev, this.page.id, toUpdate))
          }

          elementSavePromise.then((elementSaveResponse) => {
            if (
              elementSaveResponse.data.bc_document_rev_id !==
              this.bcDocumentStore.documentRev
            ) {
              // have to reload document
              //const documentReloaded = this.bcDocumentStore.willLoadDocument(this.bcDocumentStore.document.id)
              this.bcDocumentStore.willChangeRevision = true
              this.$router.replace({
                name: 'BCDocumentDetailRev',
                params: { revId: elementSaveResponse.data.bc_document_rev_id }
              }).then(() => {
                this.updateProduct(elementSaveResponse.data, val)
                resolve()
              })
              //await documentReloaded
            } else {
              this.updateProduct(elementSaveResponse.data, val)
              resolve()
            }
          })
        })
      })
    },
    async deleteProduct() {
      if (!this.product.id) {
        this.$emit('delete', this.index)
        return
      }

      this.bcDocumentStore.addToUpdateQueue(() => {
        return new Promise((resolve/*, reject*/) => {
          const productDeletePromise = handleApiError(() => documentApi.elementDeleteProduct(this.bcDocumentStore.document.id, this.bcDocumentStore.documentRev, this.page.id, this.product.id))

          productDeletePromise.then((productDeleteResponse) => {
            if (
              productDeleteResponse.data.bc_document_rev_id !==
              this.bcDocumentStore.documentRev
            ) {
              // have to reload document
              //const documentReloaded = this.bcDocumentStore.willLoadDocument(this.bcDocumentStore.document.id)
              this.bcDocumentStore.willChangeRevision = true
              this.$router.replace({
                name: 'BCDocumentDetailRev',
                params: { revId: productDeleteResponse.data.bc_document_rev_id }
              }).then(() => {
                this.$emit('delete', this.index)
                resolve()
              })
              //await documentReloaded
            
            } else {
              this.$emit('delete', this.index)
              resolve()
            }
          })
        })
      })
    },
    updateFocus() {
      this.$emit('changeFocusIndex', this.index)
    }
  },
  watch: {
    'product.price': {
      handler(val) {
        this.priceEdit = val
          ? val.price.toString()
          : '0'
      },
      immediate: true
    },
    updated: {
      handler(val) {
        if (!val) return
        this.focused = null

        this.$nextTick(() => {
          this.updated = null
          this.updateProductQueue(val)
        })
      },
      immediate: true
    },
    duplicateCode(newVal) {
      if (!newVal && this.index !== this.focusIndex) {
        this.updateProductQueue('code')
      }
    },
    focusIndex(newVal) {
      if (newVal === this.index && this.duplicateCode) {
        this.updateProductQueue('code')
      }
    }
  }
}
</script>
